import { getJWTToken } from '../../utils/auth';
import { authHeaders } from '../../core/impersonation';

const apiUrl = import.meta.env.REACT_APP_BAMBOO_API_URL ?? '';

export type PeExcludedRecord = {
  reason: string;
  records: number;
  schoolYear?: string;
  matched?: number;
  tested?: number;
};

export type PeDataStatus = {
  hasData: boolean;
  // The population is a roster feed with no WIDA upload behind it.
  assessmentDataAbsent: boolean;
  schoolYear: string | null;
  excludedRecords: PeExcludedRecord[];
  accessPresent: boolean;
  rosterStreamConnected: boolean;
  rosterStreamConnectedAt: string | null;
  sisMatchingConfirmedAt: string | null;
  sisMatchingRequired: boolean;
};

export type ServerSourcedSubmission = { source: 'server' };

export async function fetchDataStatus(): Promise<PeDataStatus> {
  const token = await getJWTToken();
  const response = await fetch(`${apiUrl}/program-evaluation/data-status`, {
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error(`program-evaluation data-status failed: ${response.status}`);
  }
  const body = (await response.json()) as Partial<PeDataStatus> | null;
  return {
    hasData: Boolean(body?.hasData),
    assessmentDataAbsent: Boolean(body?.assessmentDataAbsent),
    schoolYear: body?.schoolYear ?? null,
    excludedRecords: body?.excludedRecords ?? [],
    accessPresent: Boolean(body?.accessPresent),
    rosterStreamConnected: Boolean(body?.rosterStreamConnected),
    rosterStreamConnectedAt:
      typeof body?.rosterStreamConnectedAt === 'string' ? body.rosterStreamConnectedAt : null,
    sisMatchingConfirmedAt:
      typeof body?.sisMatchingConfirmedAt === 'string' ? body.sisMatchingConfirmedAt : null,
    sisMatchingRequired: body?.sisMatchingRequired !== false,
  };
}

// The server assembles from its own uploads, so the submission carries no data.
export async function serverSourcedSubmission(): Promise<ServerSourcedSubmission> {
  return { source: 'server' };
}
